import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=0cdfbf3e&"
import script from "./DataSource.vue?vue&type=script&lang=js&"
export * from "./DataSource.vue?vue&type=script&lang=js&"
import style0 from "./DataSource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports